export default "__VITE_ASSET__DKuScCqg__"